import AnalyticsProvider from './AnalyticsProvider'
import {Datalayer} from '../index'
import Status from '../status/Status'
import {initGtm} from '../gtm/GoogleTagManager'

export default class GTM implements AnalyticsProvider {
  private _id: string
  private _auth: string
  private _preview: string
  private _cookies_win: string
  private _dataLayerName: string
  private _dataLayer: Record<string, unknown>
  private _events: Record<string, unknown>

  isActive = true

  constructor(
    id: string,
    auth: string,
    preview: string,
    cookies_win: string,
    dataLayerName: string,
    dataLayer: Record<string, unknown>,
    event: Record<string, unknown>,
  ) {
    this._id = id
    this._auth = auth
    this._preview = preview
    this._cookies_win = cookies_win
    this._dataLayerName = dataLayerName
    this._dataLayer = dataLayer
    this._events = event
  }

  init(): Status {
    initGtm({
      id: this._id,
    })

    return new Status(this, true)
  }

  sendEvent(data: Datalayer): Promise<Status> {
    return new Promise(resolve => {
      window[this._dataLayerName].push(
        Object.assign(
          {
            event: data.event,
            eventCallback: () => {
              resolve(new Status(this, true))
            },
            eventTimeout: 2000,
          },
          data.property,
        ),
      )
    })
  }

  get id(): string {
    return this._id
  }

  set id(value: string) {
    this._id = value
  }

  get auth(): string {
    return this._auth
  }

  set auth(value: string) {
    this._auth = value
  }

  get preview(): string {
    return this._preview
  }

  set preview(value: string) {
    this._preview = value
  }

  get cookies_win(): string {
    return this._cookies_win
  }

  set cookies_win(value: string) {
    this._cookies_win = value
  }

  get dataLayerName(): string {
    return this._dataLayerName
  }

  set dataLayerName(value: string) {
    this._dataLayerName = value
  }

  get dataLayer(): Record<string, unknown> {
    return this._dataLayer
  }

  set dataLayer(value: Record<string, unknown>) {
    this._dataLayer = value
  }

  get events(): Record<string, unknown> {
    return this._events
  }

  set events(value: Record<string, unknown>) {
    this._events = value
  }
}
